import React, { useState } from 'react';
import { View, TouchableOpacity, Text, ActivityIndicator } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

import HeaderDefault from '../../components/HeaderDefault';
import { LinearGradient } from 'expo-linear-gradient';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const DeleteCard = ({ route, navigation }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { item } = route.params;

    async function deleteCard() {
        setIsLoading(true);
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.delete(`/cards/${item.id}`, { headers: { 'Authorization': `Basic ${token}` } })
            .then(() => {
                navigation.navigate('MyCards');
                setIsLoading(false);
            })
            .catch((error) => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }


    return (
        <>
            <HeaderDefault title={'Excluir cartão'} />

            <Text style={styles.textInfo}>
                Tem certeza de que deseja excluir seu cartão?
            </Text>

            <View style={styles.contentBtn}>
                <TouchableOpacity disabled={isLoading ? true : false} onPress={deleteCard}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#8F0101", "#FE5353"]}
                        style={styles.btn}
                    >
                        {isLoading ? (
                            <ActivityIndicator color="#1FBFB5" size="small" />
                        ) : (
                            <Text style={styles.textBtn}>EXCLUIR</Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    )
}

export default DeleteCard;